<template>
  <v-dialog
    :value="show"
    max-width="440"
    @input="$emit('close')"
  >
    <v-card>
      <v-card-title>QR-код приложения</v-card-title>
      <v-card-text>
        <p>
          Отсканировав код, iPhone попадает в App Store, а Android — в Google Play. Ссылки берутся из
          контактов с типами AppStore и GooglePlay: их можно менять, а напечатанный код останется рабочим.
        </p>
        <div class="d-flex justify-center app-qr__preview">
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <img
            v-else-if="preview"
            :src="preview"
            alt="QR-код приложения"
            width="240"
            height="240"
          />
        </div>
        <v-alert
          v-if="error"
          type="error"
          text
          dense
          class="mt-4 mb-0"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          :disabled="!preview"
          :loading="downloading === 'Png'"
          @click="download('Png')"
        >
          Скачать PNG
        </v-btn>
        <v-btn
          outlined
          color="primary"
          :disabled="!preview"
          :loading="downloading === 'Svg'"
          @click="download('Svg')"
        >
          Скачать SVG
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="$emit('close')"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import contactApi from '@/api/contact'

const FILE_NAME = 'mypizza-app-qr'
const FAILED = 'Не удалось получить QR-код'

const save = (blob, name) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

// Запрос идёт с responseType blob, поэтому и ошибка приходит Blob-ом: сообщение API лежит в нём JSON-ом.
const errorText = async error => {
  const body = error && error.response && error.response.data

  if (body instanceof Blob) {
    try {
      return JSON.parse(await body.text()).message || FAILED
    } catch {
      return FAILED
    }
  }

  return FAILED
}

export default {
  name: 'AppQrDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    preview: null,
    loading: false,
    downloading: null,
    error: null,
  }),
  watch: {
    show(value) {
      if (value) {
        this.load()
      } else {
        this.clear()
      }
    },
  },
  beforeDestroy() {
    this.clear()
  },
  methods: {
    async load() {
      this.clear()
      this.loading = true
      try {
        const { data } = await contactApi.getAppQr('Svg')
        this.preview = window.URL.createObjectURL(data)
      } catch (error) {
        this.error = await errorText(error)
      } finally {
        this.loading = false
      }
    },
    async download(format) {
      this.downloading = format
      try {
        const { data } = await contactApi.getAppQr(format)
        save(data, `${FILE_NAME}.${format.toLowerCase()}`)
      } catch (error) {
        this.error = await errorText(error)
      } finally {
        this.downloading = null
      }
    },
    clear() {
      if (this.preview) window.URL.revokeObjectURL(this.preview)
      this.preview = null
      this.error = null
    },
  },
}
</script>

<style lang="scss" scoped>
.app-qr__preview {
  min-height: 240px;
  align-items: center;
}
</style>
